import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import { captureAttributionFromLocation } from "@/lib/attribution";

/**
 * Initializes analytics (fail-open) and records page views on route change.
 * Captures UTM attribution into session storage without fingerprinting.
 */
export default function AnalyticsRouteListener() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    captureAttributionFromLocation(window.location);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    trackPageView({ route: location.pathname });
  }, [location.pathname]);

  return null;
}
